import type { LocatorSearchItem } from '#types/brandify'
import type { StoreShippingAddress } from '#types/cart'
import type { PickupProduct } from '#types/components/product/pickupInStore'

export default ({ item, store }: { item: PickupProduct, store: LocatorSearchItem }) => {
  const { cart } = useApi()

  const cartId = ref<string>('')
  const isReservationOpen = ref(false)
  const isReservationOutgoing = ref(false)

  const storeShippingAddress = ref<StoreShippingAddress>({
    firstName: 'store',
    lastName: 'store',
    country: useCountryCode(),
    postalCode: store.postalcode,
    addressLine1: store.address1,
    addressLine2: store.address2 ?? '',
    city: store.city,
    province: store.state ?? store.province ?? '',
    storeId: store.storeid,
    storeName: store.name
  })

  const reserve = async () => {
    isReservationOutgoing.value = true
    try {
      const selectedVariant = item.variants.filter((variant) => variant.id === item.productId)[0]
      const upc = selectedVariant.upc ?? ''

      const { id: basketId } = await cart.$reserveWithItem({
        productId: item.productId,
        maxQty: 999999,
        qty: 1,
        upc,
        shippingAddress: {
          ...storeShippingAddress.value
        }
      }, { context: 'robis' })

      cartId.value = basketId
      isReservationOpen.value = true
    }
    finally {
      isReservationOutgoing.value = false
    }
  }

  return {
    cartId,
    reserve,
    isReservationOpen,
    isReservationOutgoing,
    storeShippingAddress,
  }
}
